import React from 'react';

import {
    PushNotificationRemoveTriggerAttachment,
} from 'src/components/remove-trigger-attachment/push-notification-remove-trigger-attachment';
import {TriggerAttachment} from 'src/openapi/models/TriggerAttachment';

import {Icons, Sizes} from '@pb/kit-component-icon';
import {BasicIconButton} from '@pb/kit-component-icon-button';
import {usePushNotification} from '@pb/kit-component-push-notification';

import {removeTriggerAttachment} from './remove-trigger-attachment.module.styl';

type Props = {
    eventId: number,
    attachment: TriggerAttachment,
};

export const RemoveTriggerAttachment = ({eventId, attachment}: Props) => {
    const {onCreateNote, onCloseNote} = usePushNotification();

    const onRemove = () => {
        onCreateNote({
            id: `${attachment.id}`,
            body: () => (
                <PushNotificationRemoveTriggerAttachment
                    eventId={eventId}
                    attachment={attachment}
                    onClose={onCloseNote}
                />
            ),
            buttonProps: {icon: Icons.CLOSE},
            autoHideTimeout: 10000,
        });
    };

    return (
        <BasicIconButton
            className={removeTriggerAttachment}
            iconProps={{type: Icons.TRASH_LIGHT, size: Sizes.Size_14}}
            onClick={onRemove}
        />
    );
};
